document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.ken-services-story__text-wrapper').forEach((wrapper) => {
    const button = wrapper.nextElementSibling;
    if (!button || !button.classList.contains('ken-services-story__read-more')) return;

    if (wrapper.scrollHeight <= wrapper.clientHeight + 4) return;

    wrapper.classList.add('clamped');
    button.classList.add('visible');

    button.addEventListener('click', () => {
      const expanded = wrapper.classList.toggle('expanded');
      button.textContent = expanded ? button.dataset.readLess : button.dataset.readMore;
    });
  });
});
